'use strict';

import template from './app.html';

function ComponentController() {
    'ngInject';
}

const AppComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: ComponentController,
    replace: true
    // controllerAs: 'vm'
};


export {AppComponent};



// WEBPACK FOOTER //
// ./app/app.component.js